import {
  faAngleDown,
  faAngleUp,
  faArrowUp,
  faArrowUp19,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IKImage } from "imagekitio-react";
import React, { useEffect, useState } from "react";
import { FidgetSpinner } from "react-loader-spinner";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import {
  getPersonaliseSkillData,
  getPersonaliseSyllabusData,
} from "../../redux/actions/certificate";
import { faCheckCircle } from "@fortawesome/free-regular-svg-icons";
import Constants from "../../common/constants";
import { Mixpanel } from "../../config/Mixpanel";
import './defaultStyle.css'
import UserForm from "./UserForm";
import OwnerVariant from "./OwnerVariant/OwnerVariant";
import RecruiterVariant from "./RecruiterVariant/RecruiterVariant";
import NormalVariant from "./NormalVariant/NormalVariant";
import { getCertifiedDetails, getCertifiedToken } from "../../redux/actions/certificateVerification";
import { SET_CERTIFIED_DATA } from "../../redux/actions/types";
import LockedComponent from "./LockedComponent";


const CertificateVerificationMobileBody = ({ openLinkedInLogin ,targetRef ,  uploadRef ,handlerCertified,handlerPersonalise , requestCvRef , requestInterviewRef , loading}) => {
  const [userSkills, setUserSkills] = useState([]);
  const [syllabus, setSyllabus] = useState([]);
  const dispatch = useDispatch();

  const certificateData = useSelector((store)=> store?.certificateVerification?.certificateData);
  const isPersonalise =
    certificateData?.certificate_type === "personalized" ? true : false;
  const isCertified =
    certificateData?.certificate_type === "certified" ? true : false;
    const isSkill = certificateData?.certificate_type === "skill" ? true : false;
    const isMskill =  certificateData?.certificate_type === "mskill" ? true : false;
    const [isFormSubmitted , setIsFormSubmitted] = useState(false);
     const userDetails = useSelector((store) => store?.certificateVerification?.userInfo);
    const variant = useSelector((store)=> store?.certificateVerification?.userType);
    const [ userCertifiedData , setUserCertifiedData ] = useState({});
    const lockedState = useSelector(
        (store) => store?.certificateVerification?.is_locked
      );

  function getHeading(type) {
    let result;
    switch (type) {
      case "certified":
        result = "Quiz";
        break;
      case "personalized":
        result = "Personalised Course";
        break;
      case "task":
        result = "Project";
        break;
      default:
        result = "Course";
        break;
    }

    return result;
  }
  const [activeSkills, setActiveSkills] = useState({});

  useEffect(() => {
    if (certificateData?.certificate_type === "personalized") {
      dispatch(
        getPersonaliseSkillData(
          certificateData?.email,
          certificateData?.skill_name,
          (sucessObj) => {
            setUserSkills(sucessObj);
          },
          (errorObj) => {}
        )
      );
      

      
      dispatch(
        getPersonaliseSyllabusData(
          certificateData?.email,
          certificateData?.skill_name,
          (sucessObj) => {
            setSyllabus(sucessObj);
          },
          (errorObj) => {}
        )
      );
    }
    else if(certificateData?.certificate_type ==="skill"){
      setSyllabus(certificateData?.mskills_of_skill);
    }

    else if(certificateData?.certificate_type ==="mskill"){
      setSyllabus(certificateData?.lessons_of_mskill);
    }


    

  }, [certificateData, dispatch]);


  if(lockedState)
    return <LockedComponent openLinkedInLogin={openLinkedInLogin} handlerCertified={handlerCertified}/>;

  if(variant === "owner"){
    return <OwnerVariant openLinkedInLogin={openLinkedInLogin} uploadRef={uploadRef} handlerCertified={handlerCertified}
            handlerPersonalise={handlerPersonalise} targetRef={targetRef} loading={loading}/>
  }
  else if(variant === "recruiter"){
     return <RecruiterVariant openLinkedInLogin={openLinkedInLogin}  handlerCertified={handlerCertified}
            handlerPersonalise={handlerPersonalise} targetRef={targetRef} requestCvRef={requestCvRef} requestInterviewRef={requestInterviewRef} loading={loading}/>
  }
  else if(variant === "normal"){
     return <NormalVariant openLinkedInLogin={openLinkedInLogin} requestCvRef={requestCvRef} handlerCertified={handlerCertified}
            handlerPersonalise={handlerPersonalise} targetRef={targetRef}  loading={loading}/>
  }
  else{
    return <LockedComponent openLinkedInLogin={openLinkedInLogin} handlerCertified={handlerCertified}/>
  }
 
//   return (
//     <div
//       className="flex w-full flex-col  items-center justify-center pt-6 pb-20 leading-tight radial-gradient-background"
//     >
//       <div className="w-[90%] ">
//         <div className="text-center md:text-left">
//           <div
//             className="text-[16px] md:text-[28px] semi-transparent-text "
//           >
//             {getHeading(certificateData?.certificate_type)} Certificate
//           </div>
//           <div className="text-[24px] font-semibold text-white md:text-[44px]">
//             {certificateData?.certificate_name}
//           </div>
//         </div>
//         <div className="mt-6 flex flex-col items-center justify-center md:flex-row md:items-start md:justify-between">
//           <div className="w-full md:w-[350px] ">
            
//             <div className="mt-0 flex w-full flex-col items-center justify-center rounded-2xl bg-[#2D4F71] px-4 py-4">
//               <div className="flex items-center justify-between">
//                 {!isCertified && (
//                   <div className="mr-6 flex flex-col items-center justify-center leading-6">
//                     <div className="text-[20px] font-bold text-white ">
//                       Passed
//                     </div>
//                     <div
//                       className="text-[14px] font-semibold semi-transparent-text "
//                     >
//                       SCORE
//                     </div>
//                   </div>
//                 )}

//                 {isCertified && (
//                   <div className={`${window.innerWidth <= 360 ? 'mr-0' : 'mr-6'} flex flex-col items-center justify-center leading-6`}>
//                     <div className="text-[20px] font-bold text-white ">
//                       {certificateData?.score}%
//                     </div>
//                     <div
//                       className="text-[14px] font-semibold semi-transparent-text "
//                     >
//                       SCORE
//                     </div>
//                   </div>
//                 )}
//                 {isCertified && (
//                   <div className={`${ window.innerWidth <= 360 ? 'ml-3 mr-3': 'ml-6 mr-6'} flex flex-col items-center justify-center leading-6`}>
//                     <div className="text-[20px] font-bold text-white ">{`${
//                       certificateData?.user_rank
//                     }/${certificateData?.user_rank * 4}`}</div>
//                     <div
//                       className="text-[14px] font-semibold semi-transparent-text "
//                     >
//                       RANK
//                     </div>
//                   </div>
//                 )}

//                 <div className={`${window.innerWidth <= 360 ? 'ml-0' : 'ml-6'} flex flex-col items-center justify-center leading-6`}>
//                   {" "}
//                   <img
//                     urlEndpoint="https://assets.learntube.ai/files/"
//                     src={
//                       "https://assets.learntube.ai/files/CertificateVerification/Group%209964.svg?updatedAt=1702543641793"
//                     }
//                   />
//                   <div
//                     className="text-[14px] font-semibold semi-transparent-text "
//                   >
//                     VERIFIED
//                   </div>
//                 </div>
//               </div>
//               {isFormSubmitted && <div
//                 className="text-[16px] font-semibold text-[#7FC241] underline "
//                 onClick={(e) =>
//                   {
//                     Mixpanel.track(Constants.Mixpanel.COMPARE_YOUR_SCORE_BUTTON_CLICKED , {distinct_id : email});
//                   window.open(`https://certified.learntube.ai/skill_name=${certificateData?.certificate_name}?utm_source=certificate-verification&utm_medium=compare-score&unique_certificate_id=${certificateData?.unique_certificate_id
//                   }`, "_blank")
//                   }
//                 }
//               >
//                 Compare Your Score With
//                  {certificateData?.name?.split(" ")[0] ||
//                   certificateData?.user_analytics?.name?.split(" ")[0]}
//                 's!
//               </div>}
//             </div>
//             <div className="flex w-full items-center justify-center mt-6">
//               {!certificateData?.certificate_image_link ? (
//                 <FidgetSpinner />
//               ) : (
//                 <img
//                 alt="user certificate image"
//                   src={certificateData?.certificate_image_link}
//                   className="object-fit h-full w-full"
//                 />
//               )}
//             </div>
//             <div className="md:text-start mt-6 text-center text-[20px] font-semibold text-white md:text-[24px]">
//               Grow Your Career With LearnTube
//             </div>
//             <div className="mt-4 flex h-[175px] w-full flex-col items-center justify-center rounded-2xl bg-[#2D4F71] px-4 py-0">
//               <div className="flex items-center justify-between ">
//                 <div className="text-[20px] text-white">
//                   Take Our Quiz &{" "}
//                   <span className="font-semibold text-[#00C1FF]">
//                     Get Certified
//                   </span>{" "}
//                   In Any Skill Of Your Choice
//                 </div>
//                 <img
//                   urlEndpoint="https://assets.learntube.ai/files/"
//                   src={
//                     "https://assets.learntube.ai/files/CertificateVerification/Group%209966.svg?updatedAt=1702543642116"
//                   }
//                   className="ml-0"
//                 />
//               </div>
//               <button
//                 className="mt-5 h-[43px] w-full rounded-lg bg-[#7FC241] text-[16px] font-semibold"
//                 onClick={(e) =>{
//                   Mixpanel.track(Constants.Mixpanel.GET_CERTIFIED_BUTTON_CLICKED , {distinct_id : email});
//                   window.open(`https://certified.learntube.ai?utm_source=certificate-verification&utm_medium=get-certified&unique_certificate_id=${certificateData?.unique_certificate_id
//                   }`, "_blank")
//                 }
//                 }
//               >
//                 Get Certified Quick
//               </button>
//             </div>
//             <div className="mt-4 flex h-[175px] w-full flex-col items-center justify-center rounded-2xl bg-[#2D4F71] px-4 py-0">
//               <div className="flex items-center justify-between ">
//                 <img
//                   urlEndpoint="https://assets.learntube.ai/files/"
//                   src={
//                     "https://assets.learntube.ai/files/CertificateVerification/Group%209965.svg?updatedAt=1702543641836"
//                   }
//                   className="mr-4"
//                 />

//                 <div className="text-[20px] text-white">
//                   Build Your Own{" "}
//                   <span className="font-semibold text-[#00C1FF]">
//                     Personalised Course
//                   </span>{" "}
//                   For Any Subject
//                 </div>
//               </div>
//               <button
//                 className="mt-5 h-[43px] w-full rounded-lg bg-[#7FC241] text-[16px] font-semibold"
//                 onClick={(e) =>{
//                   Mixpanel.track(Constants.Mixpanel.BUILD_PERSONALISED_COURSE_BUTTON_CLICKED , {distinct_id : email});
//                   window.open("https://personalise.learntube.ai?utm_source=certificate-verification&utm_medium=build-course", "_blank")
//                 }
//                 }
//               >
//                 Build A Personalise Course
//               </button>
//             </div>
            
//           </div>
//           {(isPersonalise) && syllabus.length > 0 && (
//             <div className="mt-9 w-full text-white">
//               <div className="text-[20px] font-semibold">
//               {certificateData?.name?.split(" ")[0]}'s Course Syllabus
//               </div>
//               <div className="mt-4 flex w-full flex-col gap-y-4">
//                 {syllabus?.map((item, index) => (
//                   <div className="flex flex-col items-start justify-start rounded-2xl bg-[#2D4F71] p-4">
//                     <div
//                       className="flex w-full cursor-pointer flex-row items-center justify-between"
//                       onClick={(e) => {
//                         if (activeSkills[index]) {
//                           setActiveSkills((prev) => {
//                             let temp = { ...prev };
//                             temp[index] = false;
//                             return temp;
//                           });
//                         } else {
//                           setActiveSkills((prev) => {
//                             let temp = { ...prev };
//                             temp[index] = true;
//                             return temp;
//                           });
//                         }
//                       }}
//                     >
//                       <div className="flex items-center justify-center">
//                         <FontAwesomeIcon
//                           icon={faCheckCircle}
//                           size="lg"
//                           className="mr-2 text-[#00C838]"
//                         />
//                         <div className="text-[18px] font-semibold">
//                           {" "}
//                           {item?.module_name}
//                         </div>
//                       </div>
//                       <FontAwesomeIcon
//                         className=""
//                         icon={activeSkills?.[index] ? faAngleUp : faAngleDown}
//                       />
//                     </div>
//                     {activeSkills[index] &&
//                       item?.lessons?.map((subItem, subIndex) => (
//                         <div className="mt-2 flex w-full flex-row items-center justify-start py-1 ">
//                           <div className="mr-2 rounded-full bg-[#6193C4] p-1.5"></div>
//                           <div className="text-[14px] font-medium">
//                             {subItem}
//                           </div>
//                         </div>
//                       ))}
//                   </div>
//                 ))}
//               </div>
//             </div>
//           )}

//       {isSkill && syllabus?.length > 0 && (
//             <div className="mt-9 w-full text-white">
//               <div className="text-[20px] font-semibold">
//               {certificateData?.name?.split(" ")[0]}'s Course Syllabus
//               </div>
//               <div className="mt-4 flex w-full flex-col gap-y-4">
//                 {syllabus?.map((item, index) => (
//                   <div className="flex flex-col items-start justify-start rounded-2xl bg-[#2D4F71] p-4">
//                     <div
//                       className="flex w-full cursor-pointer flex-row items-center justify-between"
//                       onClick={(e) => {
//                         if (activeSkills[index]) {
//                           setActiveSkills((prev) => {
//                             let temp = { ...prev };
//                             temp[index] = false;
//                             return temp;
//                           });
//                         } else {
//                           setActiveSkills((prev) => {
//                             let temp = { ...prev };
//                             temp[index] = true;
//                             return temp;
//                           });
//                         }
//                       }}
//                     >
//                       <div className="flex items-center justify-center">
//                         <FontAwesomeIcon
//                           icon={faCheckCircle}
//                           size="lg"
//                           className="mr-2 text-[#00C838]"
//                         />
//                         <div className="text-[18px] font-semibold">
//                           {" "}
//                           {item?.['mSkill-name']}
//                         </div>
//                       </div>
//                       <FontAwesomeIcon
//                         className=""
//                         icon={activeSkills?.[index] ? faAngleUp : faAngleDown}
//                       />
//                     </div>
//                     {activeSkills[index] &&
//                       item?.lessons_of_mskill?.map((subItem, subIndex) => (
//                         <div className="mt-2 flex w-full flex-row items-center justify-start py-1 ">
//                           <div className="mr-2 rounded-full bg-[#6193C4] p-1.5"></div>
//                           <div className="text-[14px] font-medium">
//                             {subItem?.['lesson-name']}
//                           </div>
//                         </div>
//                       ))}
//                   </div>
//                 ))}
//               </div>
//             </div>
//           )}

// {isMskill && syllabus?.length > 0 && (
//             <div className="mt-9 w-full text-white">
//               <div className="text-[20px] font-semibold">
//               {certificateData?.name?.split(" ")[0]}'s Course Syllabus
//               </div>
//               <div className="mt-4 flex w-full flex-col gap-y-4">
//                 {syllabus?.map((item, index) => (
//                   <div className="flex flex-col items-start justify-start rounded-2xl bg-[#2D4F71] p-4">
//                     <div
//                       className="flex w-full flex-row items-center justify-between"
//                       onClick={(e) => {
//                         if (activeSkills[index]) {
//                           setActiveSkills((prev) => {
//                             let temp = { ...prev };
//                             temp[index] = false;
//                             return temp;
//                           });
//                         } else {
//                           setActiveSkills((prev) => {
//                             let temp = { ...prev };
//                             temp[index] = true;
//                             return temp;
//                           });
//                         }
//                       }}
//                     >
//                       <div className="flex items-center justify-center">
//                         <FontAwesomeIcon
//                           icon={faCheckCircle}
//                           size="lg"
//                           className="mr-2 text-[#00C838]"
//                         />
//                         <div className="text-[18px] font-semibold">
//                           {" "}
//                           {item?.['lesson-name']}
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           )}

//           {isPersonalise && userSkills?.length > 0 && (
//             <div className="mt-9 self-start text-[20px] font-semibold text-white">
//               {certificateData?.name?.split(" ")[0]}'s Performance in Other Skills
//             </div>
//           )}
//           {isPersonalise && userSkills?.length > 0 && (
//             <div className="mt-4 flex w-full flex-col">
//               <div className="flex flex-row items-center justify-between rounded-t-2xl bg-[#3E6D9C] p-4">
//                 <div className="text-[14px] font-semibold text-white">
//                   Skill Name
//                 </div>
//                 <div className="mr-2 text-[14px] font-semibold text-white">
//                   Score
//                 </div>
//               </div>

//               {userSkills?.map((item, index) => (
//                 <div className="flex w-full flex-row items-center justify-between border-b-[1px] border-b-[#3373B4] bg-[#2D4F71] p-4">
//                   <div className="text-[14px] font-semibold text-white underline">
//                     {item}
//                   </div>
//                   <div className="text-[14px] font-semibold text-white">
//                     PASSED
//                   </div>
//                 </div>
//               ))}
//               <div className="w-full rounded rounded-b-2xl bg-[#2D4F71] p-4">
//                 <button className="w-full rounded-lg border-2 border-[#7FC241] p-2 text-[16px] font-semibold text-[#7FC241]"  onClick={(e)=> { Mixpanel.track(Constants.Mixpanel.TEST_AND_CERTIFIY_BUTTON_CLICKED); window.open(`https://certified.learntube.ai?utm_source=certificate-verification&utm_medium=test-certify&unique_certificate_id=${certificateData?.unique_certificate_id
//                   }`,'_blank')} }>
//                   Test And Certify Your Skills
//                 </button>
//               </div>
//             </div>
//           )}

//           {(isPersonalise && userSkills?.length === 0) || (isMskill === true || isSkill === true) && (
//             <button className="mt-6 w-[80%] rounded-lg border-2  border-[#7FC241] bg-[#2D4F71] p-2 text-[16px] font-semibold text-[#7FC241]" onClick={(e)=> { Mixpanel.track(Constants.Mixpanel.TEST_AND_CERTIFIY_BUTTON_CLICKED); window.open(`https://certified.learntube.ai?utm_source=certificate-verification&utm_medium=test-certify&unique_certificate_id=${certificateData?.unique_certificate_id
//                   }`,'_blank')} }>
//               Test And Certify Your Skills
//             </button>
//           )}
//         </div>
//       </div>
//       {
//         !isFormSubmitted && <UserForm isModalEnabled={!isFormSubmitted} setIsModalEnabled={setIsFormSubmitted} certificateData={certificateData} />
//       }
//     </div>
//   );
};

export default CertificateVerificationMobileBody;
